import { CommonModule } from '@angular/common';
import { NgModule, LOCALE_ID } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { TabsModule } from 'ngx-bootstrap/tabs';
import { NgxMaskDirective, NgxMaskPipe, provideNgxMask } from 'ngx-mask'
import { PaginationModule } from 'ngx-bootstrap/pagination';
import { NgxPaginationModule } from 'ngx-pagination';
import { defineLocale } from 'ngx-bootstrap/chronos';
import { deLocale } from 'ngx-bootstrap/locale';
defineLocale('pt-br', deLocale);
import { NgChartsModule } from 'ng2-charts';
import { MatExpansionModule } from '@angular/material/expansion';
import { DataTablesModule } from 'angular-datatables';
import { CollapseModule } from 'ngx-bootstrap/collapse';
import { ConfiguracaoGeralComponent } from './admin-spgg/geral/configuracao-geral.component';
import { DadosAdicionaisModeloEditComponent } from './admin-spgg/dados-adicionais-modelo-edit/dados-adicionais-modelo-edit.component';
import { DadosAdicionaisModeloListComponent } from './admin-spgg/dados-adicionais-modelo-list/dados-adicionais-modelo-list.component';
import { ExportarListComponent } from './exportar/exportar-list/exportar-list.component';
import { DadoAdicionalItemListComponent } from './admin-spgg/dado-adicional-item/dado-adicional-item-list/dado-adicional-item-list.component';
import { DadoAdicionalItemEditComponent } from './admin-spgg/dado-adicional-item/dado-adicional-item-edit/dado-adicional-item-edit.component';
import { OrgaoSetorialistaListComponent } from './admin-spgg/orgao-setorialista-list/orgao-setorialista-list.component';
import { OrgaoSetorialistaEditComponent } from './admin-spgg/orgao-setorialista-edit/orgao-setorialista-edit.component';
import { SgoSituacoesDemandaListComponent } from './admin-spgg/sgo-situacoes-demanda-list/sgo-situacoes-demanda-list.component';
import { ProjetoCompletoRoutes } from './projeto-completo.routing';
import { DadosAdicionaisModeloResolver } from './resolver/dados-adicionais-modelo.resolver';
import { DadosAdicionaisModeloService } from './services/dados-adicionais-modelo.service';
import { NgSelectModule } from '@ng-select/ng-select';
import { ListOrgaoAgregadorResolver, ListOrgaoAllResolver, ListOrgaoProgramaResolver, ListOrgaoResolver } from './resolver/list-orgao.resolver';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { MatSortModule } from '@angular/material/sort';
import { MatDialogModule } from '@angular/material/dialog';

import { MatBottomSheetModule } from '@angular/material/bottom-sheet';
import { MatListModule } from '@angular/material/list';
import { MatButtonModule } from '@angular/material/button';

import { ListQuestionResolver } from './resolver/list-question.resolver';
import { PontosCriticosTiposListComponent } from './admin-spgg/pontos-criticos-tipos-list/pontos-criticos-tipos-list.component';
import { PontosCriticosTiposEditComponent } from './admin-spgg/pontos-criticos-tipos-edit/pontos-criticos-tipos-edit.component';
import { PontosCriticosTiposService } from './services/pontos-criticos-tipos.service';
import { OrgaoService } from 'src/app/shared/services/orgao.service';
import { UsuarioService } from 'src/app/shared/services/usuario.service';
import { ExportarDropboxListComponent } from './exportar-dropbox-list/exportar-dropbox-list.component';
import { ExportarDropboxEditComponent } from './exportar-dropbox-edit/exportar-dropbox-edit.component';
import { ExportarDropboxService } from './services/exportar-dropbox.service';
import { ExportarDropboxResolver } from './resolver/exportar-dropbox.resolver';
import { ListExportTypesResolver } from './resolver/list-export-types.resolver';
import { ListExecutionResolver } from './resolver/list-execution.resolver';
import { StatusOperacionalEditComponent } from './admin-spgg/status-operacional-edit/status-operacional-edit.component';
import { StatusOperacionalListComponent } from './admin-spgg/status-operacional-list/status-operacional-list.component';
import { StatusOperacionalService } from './services/status-operacional.servives';
import { StatusOperacionalResolver } from './resolver/status-operacionais.resolver';
import { PontosCriticosTiposResolver } from './resolver/pontos-criticos-tipos.resolver';
import { SgoSituacoesDemandaEditComponent } from './admin-spgg/sgo-situacoes-demanda-edit/sgo-situacoes-demanda-edit.component';
import { SgoSituacoesDemandaService } from './services/sgo-situacoes-demanda.service';
import { SgoSituacoesDemandaResolver } from './resolver/sgo-situacao-demanda.resolver';
import { SgoModuloService } from './services/sgo-modulo.service';
import { SgoModuloListResolver } from './resolver/sgo-modulo-list.resolver';
import { SgoModuloEditComponent } from './admin-spgg/sgo-modulo-edit/sgo-modulo-edit.component';
import { SgoModuloListComponent } from './admin-spgg/sgo-modulo-list/sgo-modulo-list.component';
import { SgoModuloResolver } from './resolver/sgo-modulo.resolver';
import { OrgaoSetorialistaService } from './services/orgao-setorialista.service';
import { OrgaoSetorialistaResolver } from './resolver/orgao-setorialista.resolver';
import { ListUsuarioResolver } from './resolver/list-usuario.resolver';
import { BiTematicaEditComponent } from './admin-spgg/bi-tematica-edit/bi-tematica-edit.component';
import { BiTematicaListComponent } from './admin-spgg/bi-tematica-list/bi-tematica-list.component';
import { BiTematicaResolver } from './resolver/bi-tematica.resolver';
import { BiTematicaService } from './services/bi-tematica.service';
import { DemandasMonitoramentoListComponent } from './demandas-monitoramento-list/demandas-monitoramento-list.component';
import { DemandasMonitoramentoService } from './services/demandas-monitoramento.service';
import { ListAndamentoDemandasResolver, ListSituacaoDemandasResolver, InfoDemandaResolver } from './resolver/demandas-monitoramento-list.resolver';
import { ImportarIrcpComponent } from './importar-ircp/importar-ircp.component';
import { ImportarIrcpModalComponent } from './importar-ircp-modal/importar-ircp-modal.component';
import { MapaComponent } from './mapa/mapa.component';
import { MapaResolver } from './resolver/mapa.resolver';
import { MinhasResponsabilidadesListComponent } from './minhas-responsabilidades-list/minhas-responsabilidades-list.component';
import { PesquisaGeralComponent } from './consulta-geral/pesquisa-geral/pesquisa-geral.component';
import { ProjetoListComponent } from './consulta-geral/projeto-list/projeto-list.component';
import { PesquisaGeralResolver } from './resolver/pesquisa-geral.resolver';
import { PesquisaGeralService } from './services/pesquisa-geral.service';
import { DetalheProjetoLayoutComponent } from './consulta-geral/detalhe-projeto-layout/detalhe-projeto-layout.component';
import { DetalheCadastroProjetoComponent } from './consulta-geral/detalhe-cadastro-projeto/detalhe-cadastro-projeto.component';
import { CadastroProjectResolver, DocumentosProjetoResolver, InfoProjetoResolver } from './resolver/projeto.resolver';
import { DetalheCadastroProdutoListComponent } from './consulta-geral/detalhe-cadastro-produto-list/detalhe-cadastro-produto-list.component';
import { DetalheDocumentoListComponent } from './consulta-geral/detalhe-documento-list/detalhe-documento-list.component';
import { DetalheDocumentoEditComponent } from './consulta-geral/detalhe-documento-edit/detalhe-documento-edit.component';
import { DocumentosProjetoService } from './services/documentos-projeto.service';
import { DetalheCadastroProdutoEditComponent } from './consulta-geral/detalhe-cadastro-produto-edit/detalhe-cadastro-produto-edit.component';
import { ProjetoCadastroService } from './services/projeto-cadastro.service';
import { FormatNameListPipe } from 'src/app/shared/pipe/name-list.pipe';
import { DetalheProjetoObrasListComponent } from './consulta-geral/detalhe-projeto-obras-list/detalhe-projeto-obras-list.component';
import { DetalheEntregaProjetoListComponent } from './consulta-geral/detalhe-entrega-projeto-list/detalhe-entrega-projeto-list.component';
import { DetalheEntregaProjetoViewComponent } from './consulta-geral/detalhe-entrega-projeto-view/detalhe-entrega-projeto-view.component';
import { DetalheEntregaProjetoEditComponent } from './consulta-geral/detalhe-entrega-projeto-edit/detalhe-entrega-projeto-edit.component';
import { EntregasProjetoService } from './services/entregas-projeto.service';
import { EntregasProjetoListEditResolver, EntregasProjetoListResolver, EntregasProjetoResolver, EntregasSimplificadaProjetoResolver } from './resolver/entregas-projeto.resolver';
import { ClonarModalComponent } from './consulta-geral/clonar-modal/clonar-modal.component';
import { DetalheProjetoAnalisesListComponent } from './consulta-geral/detalhe-projeto-analises-list/detalhe-projeto-analises-list.component';
import { DetalheProjetoAnalisesGerenteEditComponent } from './consulta-geral/detalhe-projeto-analises-gerente-edit/detalhe-projeto-analises-gerente-edit.component';
import { DetalheProjetoAnalisesGerenteListComponent } from './consulta-geral/detalhe-projeto-analises-gerente-list/detalhe-projeto-analises-gerente-list.component';
import { DetalheProjetoAnalisesSpggListComponent } from './consulta-geral/detalhe-projeto-analises-spgg-list/detalhe-projeto-analises-spgg-list.component';
import { DetalheProjetoAnalisesSpggEditComponent } from './consulta-geral/detalhe-projeto-analises-spgg-edit/detalhe-projeto-analises-spgg-edit.component';
import { DetalheCadastroProjetoEditComponent } from './consulta-geral/detalhe-cadastro-projeto-edit/detalhe-cadastro-projeto-edit.component';
import { HistoricoAtualizacoesListComponent } from './historico-atualizacoes-list/historico-atualizacoes-list.component';
import { MaskService } from 'src/app/shared/services/mask.service';
import { PermissionProjectService } from './services/permission.project.service';
import { DetalheProjetoSgoListComponent } from './consulta-geral/detalhe-projeto-sgo-list/detalhe-projeto-sgo-list.component';
import { SgoProjetoService } from './services/sgo-projeto.service';
import { DetalheIrfeListComponent } from './consulta-geral/detalhe-irfe-list/detalhe-irfe-list.component';
import { DetalheIrfeEditComponent } from './consulta-geral/detalhe-irfe-edit/detalhe-irfe-edit.component';
import { IrfeProjetoService } from './services/irfe-projeto.service';
import { IrfeProjetoResolver } from './resolver/irfe.resolver';
import { DetalheDemandasMonitoramentoListComponent } from './consulta-geral/detalhe-demandas-monitoramento-list/detalhe-demandas-monitoramento-list.component';
import { DetalheDemandasMonitoramentoEditComponent } from './consulta-geral/detalhe-demandas-monitoramento-edit/detalhe-demandas-monitoramento-edit.component';
import { DetalheDemandasMonitoramentoMensagensEditComponent } from './consulta-geral/detalhe-demandas-monitoramento-mensagens-edit/detalhe-demandas-monitoramento-mensagens-edit.component';
import { DetalheProjetoIrcpEditComponent } from './consulta-geral/detalhe-projeto-ircp-edit/detalhe-projeto-ircp-edit.component';
import { DetalheProjetoIrcpListComponent } from './consulta-geral/detalhe-projeto-ircp-list/detalhe-projeto-ircp-list.component';
import { IrcpProjetoService } from './services/ircp-projeto.service';
import { IrcpProjetoCombosResolver, IrcpProjetoResolver } from './resolver/ircp-projeto.resolver';
import { DemandasMonitoramentoMensagensComponent } from './demandas-monitoramento-mensagens/demandas-monitoramento-mensagens.component';
import { DemandasMonitoramentoCadastroComponent } from './demandas-monitoramento-cadastro/demandas-monitoramento-cadastro.component';
import { HistoricoAtualizacoesDemandasMonitoramentoListComponent } from './historico-atualizacoes-demandas-monitoramento-list/historico-atualizacoes-demandas-monitoramento-list.component';
import { DetalheProjetoIndicadoresListComponent } from './consulta-geral/detalhe-projeto-indicadores-list/detalhe-projeto-indicadores-list.component';
import { IndicadoresProjetoService } from './services/indicadores-projeto.service';
import { DetalheProjetoIndicadoresViewComponent } from './consulta-geral/detalhe-projeto-indicadores-view/detalhe-projeto-indicadores-view.component';
import { DetalheProjetoIndicadoresEditComponent } from './consulta-geral/detalhe-projeto-indicadores-edit/detalhe-projeto-indicadores-edit.component';
import { IndicadoresProjetoListEditResolver, IndicadoresProjetoListResolver, IndicadoresProjetoResolver, IndicadoresSimplificadoProjetoResolver } from './resolver/indicadores-projeto.resolver';
import { DetalheProjetoIndicadoresConfigEditComponent } from './consulta-geral/detalhe-projeto-indicadores-config-edit/detalhe-projeto-indicadores-config-edit.component';
import { DetalheProjetoIndicadoresSomatorioEditComponent } from './consulta-geral/detalhe-projeto-indicadores-somatorio-edit/detalhe-projeto-indicadores-somatorio-edit.component';
import { DetalheProjetoIndicadoresRelacionadosEditComponent } from './consulta-geral/detalhe-projeto-indicadores-relacionados-edit/detalhe-projeto-indicadores-relacionados-edit.component';
import { DetalheProjetoIndicadoresEntregasRelacionadasEditComponent } from './consulta-geral/detalhe-projeto-indicadores-entregas-relacionadas-edit/detalhe-projeto-indicadores-entregas-relacionadas-edit.component';
import { DetalheEntregaProjetoObrasListComponent } from './consulta-geral/detalhe-entrega-projeto-obras-list/detalhe-entrega-projeto-obras-list.component';
import { DetalheEntregaProjetoAgendaPositivaListComponent } from './consulta-geral/detalhe-entrega-projeto-agenda-positiva-list/detalhe-entrega-projeto-agenda-positiva-list.component';
import { DetalheProjetoDemandaMonitoramentoListComponent } from './consulta-geral/detalhe-projeto-demanda-monitoramento-list/detalhe-projeto-demanda-monitoramento-list.component';
import { DetalheEntregaProjetoRelatorioComponent } from './consulta-geral/detalhe-entrega-projeto-relatorio/detalhe-entrega-projeto-relatorio.component';
import { GenericGuard } from 'src/app/shared/guards/generic.guard';
import { AgendaPositivaService } from './services/agenda-positiva.service';
import { DetalheCronogramaProjetoListComponent } from './consulta-geral/detalhe-cronograma-projeto-list/detalhe-cronograma-projeto-list.component';
import { CronogramaProjetoService } from './services/cronograma-projeto.service';
import { DetalheProjetoPlanoAcaoListComponent } from './consulta-geral/detalhe-projeto-plano-acao-list/detalhe-projeto-plano-acao-list.component';
import { DetalheProjetoPlanoAcaoEditComponent } from './consulta-geral/detalhe-projeto-plano-acao-edit/detalhe-projeto-plano-acao-edit.component';
import { PlanoAcaoService } from './services/plano-acao.service';
import { PlanoAcaoListResolver, PlanoAcaoResolver, PlanoAcaoSimplificadoResolver } from './resolver/plano-acao.resolver';
import { DetalheProjetoPlanoAcaoViewComponent } from './consulta-geral/detalhe-projeto-plano-acao-view/detalhe-projeto-plano-acao-view.component';
import { DetalheProjetoSituacaoEditComponent } from './consulta-geral/detalhe-projeto-situacao-edit/detalhe-projeto-situacao-edit.component';
import { PlanoAcaoSituacaoService } from './services/plano-acao-situacao.service';
import { PlanoAcaoSituacaoListResolver, PlanoAcaoSituacaoResolver } from './resolver/plano-acao-situacao.resolver';
import { FormatStatusAndamentoPipe } from 'src/app/shared/pipe/status-andamento.pipe';
import { DetalheProjetoPontosCriticosListComponent } from './consulta-geral/detalhe-projeto-pontos-criticos-list/detalhe-projeto-pontos-criticos-list.component';
import { DetalheProjetoPontosCriticosEditComponent } from './consulta-geral/detalhe-projeto-pontos-criticos-edit/detalhe-projeto-pontos-criticos-edit.component';
import { DetalheProjetoIndicadoresAnaliseListComponent } from './consulta-geral/detalhe-projeto-indicadores-analise-list/detalhe-projeto-indicadores-analise-list.component';
import { DetalheProjetoIndicadoresAnaliseEditComponent } from './consulta-geral/detalhe-projeto-indicadores-analise-edit/detalhe-projeto-indicadores-analise-edit.component';
import { IndicadoresAnaliseService } from './services/indicadores-analise.service';
import { IndicadoresAnaliseListResolver, IndicadoresAnaliseResolver } from './resolver/indicadores-analise.resolver';
import { DetalheEntregaProjetoAnaliseListComponent } from './consulta-geral/detalhe-entrega-projeto-analise-list/detalhe-entrega-projeto-analise-list.component';
import { DetalheEntregaProjetoAnaliseEditComponent } from './consulta-geral/detalhe-entrega-projeto-analise-edit/detalhe-entrega-projeto-analise-edit.component';
import { EntregasAnaliseResolver, EntregasAnaliseListResolver } from './resolver/entregas-analise.resolver';
import { EntregasAnaliseService } from './services/entregas-analise.service';
import { PreDemandaResolver } from './resolver/demanda-monitoramento.resolver';
import { DetalheExecucaoOrcamentariaListComponent } from './consulta-geral/detalhe-execucao-orcamentaria-list/detalhe-execucao-orcamentaria-list.component';
import { ExecucaoOrcamentariaService } from './services/execucao-orcamentaria.service';
import { IndicadoresAtividadeResolver, IndicadoresAtividadeSimplificadoResolver, IndicadoresAtividadeListResolver } from './resolver/indicadores-atividade.resolver';
import { IndicadoresAtividadeService } from './services/indicadores-atividade.service';
import { IndicadoresAtividadeSituacaoListResolver, IndicadoresAtividadeSituacaoResolver } from './resolver/indicadores-atividade-situacao.resolver';
import { IndicadoresAtividadeSituacaoService } from './services/indicadores-atividade-situacao.service';
import { ProaService } from './consulta-geral/processos/services/proa.service';
import { DetalheProjetoExecucaoOrcamentariaEditComponent } from './consulta-geral/detalhe-projeto-execucao-orcamentaria-edit/detalhe-projeto-execucao-orcamentaria-edit.component';
import { DetalheProjetoExecucaoOrcamentariaViewComponent } from './consulta-geral/detalhe-projeto-execucao-orcamentaria-view/detalhe-projeto-execucao-orcamentaria-view.component';
import { ExecucaoOrcamentariaPermissionResolver } from './resolver/execucao-orcamentaria.resolver';
import { DetalheProjetoExecucaoOrcamentariaConfigComponent } from './consulta-geral/detalhe-projeto-execucao-orcamentaria-config/detalhe-projeto-execucao-orcamentaria-config.component';
import { DetalheProjetoExecucaoOrcamentariaItensComponent } from './consulta-geral/detalhe-projeto-execucao-orcamentaria-itens/detalhe-projeto-execucao-orcamentaria-itens.component';
import { DetalheProjetoExecucaoOrcamentariaLoaListComponent } from './consulta-geral/detalhe-projeto-execucao-orcamentaria-loa-list/detalhe-projeto-execucao-orcamentaria-loa-list.component';
import { DetalheProjetoExecucaoOrcamentariaLoaNewComponent } from './consulta-geral/detalhe-projeto-execucao-orcamentaria-loa-new/detalhe-projeto-execucao-orcamentaria-loa-new.component';
import { DetalheProjetoExecucaoOrcamentariaExecucaoEditComponent } from './consulta-geral/detalhe-projeto-execucao-orcamentaria-execucao-edit/detalhe-projeto-execucao-orcamentaria-execucao-edit.component';
import { DetalheProjetoIndicadoresMetaRealizadoComponent } from './consulta-geral/detalhe-projeto-indicadores-meta-realizado/detalhe-projeto-indicadores-meta-realizado.component';
import { DetalhePgIndicadoresEditComponent } from './consulta-geral/detalhe-pg-indicadores-edit/detalhe-pg-indicadores-edit.component';
import { DetalhePgIndicadoresViewComponent } from './consulta-geral/detalhe-pg-indicadores-view/detalhe-pg-indicadores-view.component';
import { DetalhePgIndicadoresConfigEditComponent } from './consulta-geral/detalhe-pg-indicadores-config-edit/detalhe-pg-indicadores-config-edit.component';
import { IndicadoresSimplificadoPgResolver, IndicadoresPgListResolver, IndicadoresPgListEditResolver, IndicadoresPgResolver } from './resolver/indicadores-pg.resolver';
import { IndicadoresPgService } from './services/indicadores-pg.service';
import { DetalhePgIndicadoresSomatorioEditComponent } from './consulta-geral/detalhe-pg-indicadores-somatorio-edit/detalhe-pg-indicadores-somatorio-edit.component';
import { DetalhePgIndicadoresMetaEditComponent } from './consulta-geral/detalhe-pg-indicadores-meta-edit/detalhe-pg-indicadores-meta-edit.component';
import { DetalhePgDocumentoEditComponent } from './consulta-geral/detalhe-pg-documento-edit/detalhe-pg-documento-edit.component';
import { IndicadoresPgAtividadeService } from './services/indicadores-pg-atividade.service';
import { DetalhePgLayoutComponent } from './consulta-geral/detalhe-pg-layout/detalhe-pg-layout.component';
import { IndicadoresPgAtividadeResolver, IndicadoresPgAtividadeSimplificadoResolver, IndicadoresPgAtividadeListResolver } from './resolver/indicadores-pg-atividade.service';
import { DetalheProjetoProaEditComponent } from './consulta-geral/detalhe-projeto-proa-edit/detalhe-projeto-proa-edit.component';
import { IndicadoresPgAtividadeSituacaoListResolver, IndicadoresPgAtividadeSituacaoResolver } from './resolver/indicadores-pg-atividade-situacao.resolver';
import { IndicadoresPgAnaliseService } from './services/indicadores-pg-analise.service';
import { IndicadoresPgAnaliseResolver, IndicadoresPgAnaliseListResolver } from './resolver/indicadores-pg-analise.resolver';
import { DetalhePgIndicadoresAnaliseEditComponent } from './consulta-geral/detalhe-pg-indicadores-analise-edit/detalhe-pg-indicadores-analise-edit.component';
import { DetalhePgIndicadoresMetaRealizadoComponent } from './consulta-geral/detalhe-pg-indicadores-meta-realizado/detalhe-pg-indicadores-meta-realizado.component';
import { DetalhePgIndicadoresListComponent } from './consulta-geral/detalhe-pg-indicadores-list/detalhe-pg-indicadores-list.component';
import { IndicadoresPgAtividadeSituacaoService } from './services/indicadores-pg-atividade-situacao.service';
import { ProjetoAgregadorService } from './services/projeto-agregador.service';
import { AgregadorCadastroViewComponent } from './consulta-geral/agregador/view/agregador-cadastro-view/agregador-cadastro-view.component';
import { AgregadorListaViewComponent } from './consulta-geral/agregador/view/agregador-lista-view/agregador-lista-view.component';
import { AgregadorCadastroEditComponent } from './consulta-geral/agregador/edit/agregador-cadastro-edit/agregador-cadastro-edit.component';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { AgregadorCadastroAddComponent } from './consulta-geral/agregador/add/agregador-cadastro-add/agregador-cadastro-add.component';
import { AgregadorLayoutComponent } from './consulta-geral/agregador/agregador-layout.component';
import { PesquisaProjetoAgregadorComponent } from './consulta-projeto-agregador/consulta-projeto-agregador.component';
import { PesquisaProgramaComponent } from './programa/pesquisa-programa/pesquisa-programa.component';
import { NgxCurrencyModule } from 'ngx-currency';
import { ProgramaEditComponent } from './programa/programa-edit/programa-edit.component';
import { ProgramaLayoutComponent } from './programa/programa-layout.component';
import { ProgramaViewComponent } from './programa/programa-view/programa-view.component';
import { ProgramaAgregadorListComponent } from './programa/programa-agregador-list/programa-agregador-list.component';
import { ProjetoAddComponent } from './projeto/projeto-add/projeto-add.component';
import { ProgramaProjetoListComponent } from './programa/programa-projeto-list/programa-projeto-list.component';
import { DetalheProjetoIrcpProaListComponent } from './consulta-geral/detalhe-projeto-ircp-proa-list/detalhe-projeto-ircp-proa-list.component';
import { HistoricoAtualizacoesProaListComponent } from './historico-atualizacoes-proa-list/historico-atualizacoes-proa-list.component';
import { ModalResponsavelComponent } from './modal-responsavel/modal-responsavel.component';
import { AditivoIrcpIrfeListComponent } from './consulta-geral/aditivo-ircp-irfe-list/aditivo-ircp-irfe-list.component';
import { AditivoIrcpIrfeEditComponent } from './consulta-geral/aditivo-ircp-irfe-edit/aditivo-ircp-irfe-edit.component';
import { PontoCriticoAcaoService } from './services/ponto-critico-acao.service';
import { PontosCriticosAcaoEditComponent } from './consulta-geral/pontos-criticos-acao-edit/pontos-criticos-acao-edit.component';
import { PontosCriticosAcaoViewComponent } from './consulta-geral/pontos-criticos-acao-view/pontos-criticos-acao-view.component';
import { PontoCriticoAcaoSimplificadoResolver } from './resolver/pontos-criticos-acao.resolver';
import { PontosCriticosAcaoSituacaoEditComponent } from './consulta-geral/pontos-criticos-acao-situacao-edit/pontos-criticos-acao-situacao-edit.component';
import { PontoCriticoAcaoSituacaoService } from './services/ponto-critico-acao-situacao.service';
import { BottomSheetComponent } from './consulta-geral/bottom-sheet/bottom-sheet.component';
import { ModalSolicitacaoComponent } from './modal-solicitacao/modal-solicitacao.component';
import { SharedModule } from 'src/app/shared/shared.module';
import { ProgramaAddComponent } from './programa/programa-add/programa-add.component';
import { PfTutorialListComponent } from './pf-tutorial-list/pf-tutorial-list.component';
import { PfTutorialEditComponent } from './pf-tutorial-edit/pf-tutorial-edit.component';

import { registerLocaleData } from '@angular/common';
import localePt from '@angular/common/locales/pt';
import { MatTooltipModule } from '@angular/material/tooltip';
import { ProcessoAllListComponent } from './consulta-geral/processos/components/processo-all-list/processo-all-list.component';
import { ProcessoListComponent } from './consulta-geral/processos/components/processo-list/processo-list.component';
import { SeiService } from './consulta-geral/processos/services/sei.service';
import { ProcessoEditComponent } from './consulta-geral/processos/components/processo-edit/processo-edit.component';
import { DetalheProjetoIrcpSeiListComponent } from './consulta-geral/detalhe-projeto-ircp-sei-list/detalhe-projeto-ircp-sei-list.component';

registerLocaleData(localePt);
@NgModule({
  imports: [
    CommonModule,
    DataTablesModule,
    FormsModule,
    ReactiveFormsModule,
    CollapseModule.forRoot(),
    ProjetoCompletoRoutes,
    NgSelectModule,
    DragDropModule,
    MatSortModule,
    MatDialogModule,
    BsDatepickerModule.forRoot(),
    NgxMaskDirective,
    NgxMaskPipe,
    NgChartsModule,
    TabsModule.forRoot(),
    TooltipModule.forRoot(),
    NgxCurrencyModule,
    PaginationModule.forRoot(),
    NgxPaginationModule,
    MatButtonModule,
    MatBottomSheetModule,
    MatListModule,
    SharedModule,
    MatExpansionModule,
    MatTooltipModule,
  ],
  exports: [
  ],
  declarations: [
    ConfiguracaoGeralComponent,
    SgoSituacoesDemandaListComponent,
    ExportarListComponent,
    DadoAdicionalItemListComponent,
    DadoAdicionalItemEditComponent,
    OrgaoSetorialistaListComponent,
    OrgaoSetorialistaEditComponent,
    DadosAdicionaisModeloListComponent,
    DadosAdicionaisModeloEditComponent,
    ExportarDropboxListComponent,
    ExportarDropboxEditComponent,
    PontosCriticosTiposListComponent,
    PontosCriticosTiposEditComponent,
    StatusOperacionalListComponent,
    StatusOperacionalEditComponent,
    SgoSituacoesDemandaEditComponent,
    SgoModuloListComponent,
    SgoModuloEditComponent,
    BiTematicaEditComponent,
    BiTematicaListComponent,
    DemandasMonitoramentoListComponent,
    ImportarIrcpComponent,
    ImportarIrcpModalComponent,
    MapaComponent,
    MinhasResponsabilidadesListComponent,
    PesquisaGeralComponent,
    ProjetoListComponent,
    DetalheProjetoLayoutComponent,
    DetalheCadastroProjetoComponent,
    DetalheCadastroProdutoListComponent,
    DetalheDocumentoListComponent,
    DetalheDocumentoEditComponent,
    DetalheCadastroProdutoEditComponent,
    FormatNameListPipe,
    DetalheProjetoObrasListComponent,
    DetalheEntregaProjetoListComponent,
    DetalheEntregaProjetoViewComponent,
    DetalheEntregaProjetoEditComponent,
    ClonarModalComponent,
    DetalheProjetoAnalisesListComponent,
    DetalheProjetoAnalisesGerenteEditComponent,
    DetalheProjetoAnalisesGerenteListComponent,
    DetalheProjetoAnalisesSpggListComponent,
    DetalheProjetoAnalisesSpggEditComponent,
    DetalheCadastroProjetoEditComponent,
    HistoricoAtualizacoesListComponent,
    HistoricoAtualizacoesDemandasMonitoramentoListComponent,
    DetalheProjetoSgoListComponent,
    DetalheIrfeListComponent,
    DetalheIrfeEditComponent,
    DetalheProjetoIrcpEditComponent,
    DetalheProjetoIrcpListComponent,
    DetalheDemandasMonitoramentoListComponent,
    DetalheDemandasMonitoramentoEditComponent,
    DetalheDemandasMonitoramentoMensagensEditComponent,
    DemandasMonitoramentoMensagensComponent,
    DemandasMonitoramentoCadastroComponent,
    DetalheProjetoIndicadoresListComponent,
    DetalheProjetoIndicadoresViewComponent,
    DetalheProjetoIndicadoresEditComponent,
    DetalheProjetoIndicadoresConfigEditComponent,
    DetalheProjetoIndicadoresSomatorioEditComponent,
    DetalheProjetoIndicadoresRelacionadosEditComponent,
    DetalheProjetoIndicadoresEntregasRelacionadasEditComponent,
    DetalheEntregaProjetoObrasListComponent,
    DetalheEntregaProjetoAgendaPositivaListComponent,
    DetalheProjetoDemandaMonitoramentoListComponent,
    DetalheEntregaProjetoRelatorioComponent,
    DetalheCronogramaProjetoListComponent,
    DetalheProjetoPlanoAcaoListComponent,
    DetalheProjetoPlanoAcaoEditComponent,
    DetalheProjetoPlanoAcaoViewComponent,
    DetalheProjetoSituacaoEditComponent,
    FormatStatusAndamentoPipe,
    DetalheProjetoPontosCriticosListComponent,
    DetalheProjetoPontosCriticosEditComponent,
    DetalheProjetoIndicadoresAnaliseListComponent,
    DetalheProjetoIndicadoresAnaliseEditComponent,
    DetalheEntregaProjetoAnaliseListComponent,
    DetalheEntregaProjetoAnaliseEditComponent,
    DetalheExecucaoOrcamentariaListComponent,
    DetalheProjetoExecucaoOrcamentariaEditComponent,
    DetalheProjetoExecucaoOrcamentariaViewComponent,
    DetalheProjetoExecucaoOrcamentariaConfigComponent,
    DetalheProjetoExecucaoOrcamentariaItensComponent,
    DetalheProjetoExecucaoOrcamentariaLoaListComponent,
    DetalheProjetoExecucaoOrcamentariaLoaNewComponent,
    DetalheProjetoExecucaoOrcamentariaExecucaoEditComponent,
    DetalheProjetoIndicadoresMetaRealizadoComponent,
    DetalhePgIndicadoresEditComponent,
    DetalhePgIndicadoresViewComponent,
    DetalhePgIndicadoresConfigEditComponent,
    DetalhePgIndicadoresSomatorioEditComponent,
    DetalhePgIndicadoresMetaEditComponent,
    DetalhePgDocumentoEditComponent,
    DetalhePgLayoutComponent,
    DetalheProjetoProaEditComponent,
    DetalhePgIndicadoresAnaliseEditComponent,
    DetalhePgIndicadoresMetaRealizadoComponent,
    DetalhePgIndicadoresListComponent,
    AgregadorCadastroViewComponent,
    AgregadorListaViewComponent,
    AgregadorCadastroEditComponent,
    AgregadorCadastroAddComponent,
    AgregadorLayoutComponent,
    PesquisaProjetoAgregadorComponent,
    PesquisaProgramaComponent,
    ProgramaEditComponent,
    ProgramaLayoutComponent,
    ProgramaViewComponent,
    ProgramaAgregadorListComponent,
    ProjetoAddComponent,
    ProgramaProjetoListComponent,
    DetalheProjetoIrcpProaListComponent,
    DetalheProjetoIrcpSeiListComponent,
    HistoricoAtualizacoesProaListComponent,
    ModalResponsavelComponent,
    AditivoIrcpIrfeListComponent,
    AditivoIrcpIrfeEditComponent,
    PontosCriticosAcaoEditComponent,
    PontosCriticosAcaoViewComponent,
    PontosCriticosAcaoSituacaoEditComponent,
    BottomSheetComponent,
    ModalSolicitacaoComponent,
    ProgramaAddComponent,
    PfTutorialListComponent,
    PfTutorialEditComponent,
    ProcessoAllListComponent,
    ProcessoListComponent,
    ProcessoEditComponent
  ],
  providers: [
    { provide: LOCALE_ID, useValue: 'pt-BR' },
    provideNgxMask(),
    PontosCriticosTiposService,
    PontosCriticosTiposResolver,
    DadosAdicionaisModeloService,
    OrgaoService,
    UsuarioService,
    DadosAdicionaisModeloResolver,
    ListOrgaoResolver,
    ListOrgaoAllResolver,
    ListOrgaoProgramaResolver,
    ListOrgaoAgregadorResolver,
    ListQuestionResolver,
    ExportarDropboxService,
    ExportarDropboxResolver,
    ListExportTypesResolver,
    ListExecutionResolver,
    ListUsuarioResolver,
    StatusOperacionalService,
    StatusOperacionalResolver,
    SgoSituacoesDemandaService,
    SgoSituacoesDemandaResolver,
    SgoModuloService,
    SgoModuloListResolver,
    SgoModuloResolver,
    OrgaoSetorialistaService,
    OrgaoSetorialistaResolver,
    BiTematicaService,
    BiTematicaResolver,
    DemandasMonitoramentoService,
    ListAndamentoDemandasResolver,
    ListSituacaoDemandasResolver,
    MapaResolver,
    PesquisaGeralService,
    PesquisaGeralResolver,
    InfoProjetoResolver,
    CadastroProjectResolver,
    DocumentosProjetoService,
    DocumentosProjetoResolver,
    ProjetoCadastroService,
    ProjetoAgregadorService,
    EntregasProjetoService,
    EntregasSimplificadaProjetoResolver,
    EntregasProjetoResolver,
    EntregasProjetoListResolver,
    EntregasProjetoListEditResolver,
    MaskService,
    PermissionProjectService,
    SgoProjetoService,
    IrfeProjetoService,
    IrfeProjetoResolver,
    IrcpProjetoService,
    IrcpProjetoCombosResolver,
    IrcpProjetoResolver,
    IndicadoresProjetoService,
    IndicadoresSimplificadoProjetoResolver,
    IndicadoresProjetoListResolver,
    IndicadoresProjetoResolver,
    IndicadoresProjetoListEditResolver,
    GenericGuard,
    AgendaPositivaService,
    CronogramaProjetoService,
    PlanoAcaoService,
    PontoCriticoAcaoService,
    PlanoAcaoResolver,
    PlanoAcaoSimplificadoResolver,
    PlanoAcaoListResolver,
    PlanoAcaoSituacaoService,
    PlanoAcaoSituacaoResolver,
    PlanoAcaoSituacaoListResolver,
    IndicadoresAnaliseService,
    IndicadoresAnaliseResolver,
    IndicadoresAnaliseListResolver,
    EntregasAnaliseService,
    EntregasAnaliseResolver,
    EntregasAnaliseListResolver,
    PreDemandaResolver,
    IndicadoresAtividadeService,
    IndicadoresAtividadeResolver,
    IndicadoresAtividadeSimplificadoResolver,
    IndicadoresAtividadeListResolver,
    IndicadoresAtividadeSituacaoService,
    IndicadoresAtividadeSituacaoListResolver,
    IndicadoresAtividadeSituacaoResolver,
    ProaService,
    ExecucaoOrcamentariaService,
    ExecucaoOrcamentariaPermissionResolver,
    IndicadoresPgService,
    IndicadoresSimplificadoPgResolver,
    IndicadoresPgListResolver,
    IndicadoresPgListEditResolver,
    IndicadoresPgResolver,
    IndicadoresPgAtividadeService,
    IndicadoresPgAtividadeResolver,
    IndicadoresPgAtividadeSimplificadoResolver,
    IndicadoresPgAtividadeListResolver,
    IndicadoresPgAtividadeSituacaoService,
    IndicadoresPgAtividadeSituacaoListResolver,
    IndicadoresPgAtividadeSituacaoResolver,
    IndicadoresPgAnaliseService,
    IndicadoresPgAnaliseResolver,
    IndicadoresPgAnaliseListResolver,
    InfoDemandaResolver,
    PontoCriticoAcaoService,
    PontoCriticoAcaoSimplificadoResolver,
    PontoCriticoAcaoSituacaoService,
    SeiService
  ],
})
export class ProjetoCompletoModule { }
